export default __webpack_public_path__ + "static/media/PlatinumCard.305ebd41.png";